import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'INBOX_CONVERSATIONS';

export const {
    action: search,
    success: searchSuccess,
    failed: searchFailed,
    aborted: searchAborted,
} = createAction(
    `${domain}/SEARCH`,
    (institutionIds, queryString) => ({institutionIds, queryString}),
    results => ({results}),
    e => ({e}),
    abortReason => ({abortReason}),
);

export const {action: setCurrentQuery} = createAction(`${domain}/SET_QUERY`, queryString => ({queryString}));

export const {action: selectNextSearchResult} = createAction(`${domain}/SELECT_NEXT_SEARCH_RESULT`, direction => ({
    direction,
}));

export const {action: selectSearchResult} = createAction(`${domain}/SELECT_SEARCH_RESULT`, index => ({index}));
